import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, SimpleChanges, Renderer2, OnDestroy, AfterViewInit, DoCheck, ViewChild, TemplateRef } from '@angular/core';
import { AutomationService } from 'src/app/services/automation.service';
import { DeviceColumnService } from 'src/app/services/device-column.service';
import { GroupService } from 'src/app/services/group.service';
import { LogcatService } from 'src/app/services/logcat.service';
import { LoginService } from 'src/app/services/login.service';
import { StandaloneService } from 'src/app/services/standalone.service';
import { TrackerService } from 'src/app/services/tracker.service';
import { Router } from '@angular/router';
import { color } from 'highcharts';
import { StackService } from 'src/app/services/stack-service.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { DeviceService } from 'src/app/services/device.service';
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';
import { DeviceListEmptyComponent } from '../device-list-empty/device-list-empty.component';


@Component({
    selector: 'app-device-list-icons',
    templateUrl: './device-list-icons.component.html',
    styleUrls: ['./device-list-icons.component.css'],
    standalone: true,
    imports: [TranslateModule, FormsModule, DeviceListEmptyComponent]
})
export class DeviceListIconsComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  modalRef!: MatDialogRef<any>;
  @ViewChild('alerttemplate') alertTemplate!: TemplateRef<any>;
  @ViewChild('alerttemplateSocketLost') alertTemplateForSocketLost!: TemplateRef<any>;
  @ViewChild('deviceAlert') deviceAlertTemplate!: TemplateRef<any>;
  msg: string = "";
  currentUser: any;
  columnDefinitions: any;
  @Input() tracker: TrackerService;
  @Input() columns: { name: string, selected: boolean }[];
  @Input() sort: {
    fixed: { name: string; order: string }[];
    user: { name: string; order: string }[];
  };
  @Input() filter: any;

  activeColumns = [];
  activeSorting = [];
  activeFilters = [];
  sortedColumns: any;
  list: any;
  items: Element[];
  device: any;
  prefix = 'd' + Math.floor(Math.random() * 1000000) + '-';
  mapping = Object.create(null);
  bridgeHost: any;
  private intervalId: any;
  priorityOrder = {
    'Stop Using': 0,
    'Use': 1,
    'Preparing': 2,
    'Ready': 3,
    'Busy': 4,
    'Connected': 5,
    'Unauthorized': 6,
    'Stop Automation': 7,
    'Offline': 8,
    'Disconnected': 9,
    'Unknown': 10
    // 'Unknown': 0,
    // 'Disconnected': 1,
    // 'Offline': 2,
    // 'Stop Automation': 3,
    // 'Unauthorized': 4,
    // 'Connected': 5,
    // 'Busy': 6,
    // 'Ready': 7,
    // 'Preparing': 8,
    // 'Use': 9,
    // 'Stop Using': 10
  };
  groupId: any;


  constructor(
    private loginService: LoginService,
    private elementRef: ElementRef,
    private logcatService: LogcatService,
    private automationService: AutomationService,
    private renderer: Renderer2,
    private standaloneService: StandaloneService,
    private deviceColumnService: DeviceColumnService,
    private groupService: GroupService,
    private Router: Router,
    private stackService: StackService,
    private dialog: MatDialog,
    private deviceService: DeviceService

  ) {
    this.loginService.currentUser.subscribe(x => this.currentUser = x);
  }

  ngOnInit(): void {
    // Import column definitions
    this.columnDefinitions = this.deviceColumnService.columnDefinitions;
    this.list = this.elementRef.nativeElement.querySelector('ul');
    this.items = Array.from(this.list.children) as Element[];
  }

  ngOnChanges(changes: SimpleChanges) {



    // Watch for column updates
    if (changes['columns'] && !changes['columns'].firstChange) {
      const newValue = changes['columns'].currentValue as { name: string, selected: boolean }[];
      this.updateColumns(newValue);
    }



    // Watch for sorting changes
    if (this.sort) {
      this.activeSorting = this.sort.fixed.concat(this.sort.user);
      this.sortedColumns = {};
      this.activeSorting.forEach((sort) => {
        this.sortedColumns[sort.name] = sort;
      });
      this.sortAll();
    }

    // Watch for filter updates.
    if (changes['filter']) {

      this.list = this.elementRef.nativeElement.querySelector('ul');
      this.items = Array.from(this.list.children) as Element[];

      const newValue = changes['filter'].currentValue;

      this.updateFilters(newValue);
      // setTimeout(() => {

      //   this.updateFilters(newValue);
      // }, 500);

    }
  }

  ngAfterViewInit() {
    this.tracker.devices.forEach(this.addListener);
    this.tracker.trackerEventEmitter.subscribe((data: any) => {
      this.list = this.elementRef.nativeElement.querySelector('ul');
      this.items = Array.from(this.list.children) as Element[];

      if (data.type == "add") {
        this.addListener(data.data);
      }
      if (data.type == "change") {
        this.changeListener(data.data);
      }
      if (data.type == "remove") {
        this.removeListener(data.data);
      }
    });

    this.list = this.elementRef.nativeElement.querySelector('ul');

    this.items = Array.from(this.list.children) as Element[];

    const element = this.elementRef.nativeElement;

    this.renderer.listen(element, 'click', (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      let id: string;



      if (target.classList.contains('thumbnail')) {
        id = target.id;
      } else if (
        target.classList.contains('device-status') ||
        target.classList.contains('device-photo-small') ||
        target.classList.contains('device-name')
      ) {
        id = ((target.parentNode as HTMLElement).parentNode as HTMLElement).id;
      } else if ((target.parentNode as HTMLElement).classList.contains('device-photo-small')) {
        id = (((target.parentNode as HTMLElement).parentNode as HTMLElement).parentNode as HTMLElement).id;
      }

      if (id) {
        const device = this.mapping[id];


        if (device.using && device.usable) {
          // Code for using and usable devices
        }

        // && target.classList.contains('btn') && target.classList.contains('state-using')
        if (device.using && target.classList.contains('btn') && target.classList.contains('state-using')) {

          this.kickDevice(device, true);

          event.preventDefault();
          // this.Router.navigate(['devices'])
          return;
        }

        const currentUser: any = this.currentUser.userObj;
        //handles the condition where the admin tries to access a device that is already in use by another user
        if (device.using && currentUser.privilege == 'admin' && device.owner.name !== "admin") {
          // Code for using and usable devices
          this.device = device;
          this.groupId = currentUser.groups.subscribed[0];
          this.openAlertMod2(this.deviceAlertTemplate, "Device is already in use by " + device.owner.email + ". Do you really want to take the device?");
          return;
        }

        const groupId = currentUser.groups.subscribed[0];
        //handles the condition where user clicks on an unusable device
        if (!device.usable) {
          this.msg = "Please Select a usable device!";
          this.openAlertMod(this.alertTemplate, this.msg);
          // alert("Please Select a usable device!")
          return;
        }
        if (
          !target.classList.contains('btn') ||
          !target.classList.contains('state-using')
        ) {
          //check before routing to /control
          this.checkDeviceStatus(device.serial).subscribe((res: any) => {
            if (res.description && res.description?.email != this.currentUser.email) {
              this.msg = "Device instance is not updated.";
              this.openAlertMod2(this.alertTemplateForSocketLost, this.msg);
            } else {
              this.checkGroupValidation(groupId, device.serial);
            }

          })
        }

        if (event.altKey && device.state === 'available') {
          this.inviteDevice(device);
          event.preventDefault();
        }

        if (event.shiftKey && device.state === 'available') {
          this.standaloneService.open(device);
          event.preventDefault();
        }
      }
    });
  }


  ngOnDestroy() {
    clearInterval(this.intervalId);
    // this.tracker.removeListener('add', this.addListener)
    // this.tracker.removeListener('change', this.changeListener)
    // this.tracker.removeListener('remove', this.removeListener)
  }

  // build(): HTMLLIElement {
  // const li = document.createElement('li');
  // this.renderer.setStyle(li, 'background-color', 'white');
  // this.renderer.setStyle(li, 'width', '10em');
  // this.renderer.setStyle(li, 'margin', '0');
  // this.renderer.setStyle(li, 'box-shadow', '2px 2px 4px #88898d');

  // this.renderer.listen(li, 'mouseenter', () => {
  //   this.renderer.setStyle(li, 'box-shadow', '6px 6px 4px rgba(0, 0, 0, 0.2)');
  // });
  // this.renderer.listen(li, 'mouseleave', () => {
  //   this.renderer.removeStyle(li, 'transform');
  //   this.renderer.setStyle(li, 'box-shadow', '2px 2px 4px #88898d');
  // });
  // this.renderer.listen(li, 'mousedown', () => {
  //   this.renderer.setStyle(li, "transform", "translateY(4px)");
  // });

  // li.className = 'cursor-select pointer thumbnail';

  // const a = document.createElement('a');
  // li.appendChild(a);

  // const photo = document.createElement('div');
  // photo.className = 'device-photo-small';
  // this.renderer.setStyle(photo, 'position', 'relative');

  // const defaultImg = document.createElement('img');
  // // defaultImg.src = this.device?.enhancedImage24 || 'assets/x24/_default.jpg';
  // defaultImg.alt = 'Default Device Thumbnail';
  // this.renderer.setStyle(defaultImg, 'width', '35%');
  // this.renderer.setStyle(defaultImg, 'height', 'auto'); // Changed from '-1%' to 'auto'
  // this.renderer.setStyle(defaultImg, 'position', 'relative');
  // this.renderer.setStyle(defaultImg, 'z-index', '0');
  // photo.appendChild(defaultImg);

  // const deviceSerial = this.device?.serial || this.device?.deviceSerial || this.device?.id;
  // const hasScreenshotFromService = this.device?.screenshotImage;
  // const hasScreenshotFromSession = deviceSerial ? sessionStorage.getItem(`deviceScreenshot-${deviceSerial}`) : null;

  // const screenshotSrc = hasScreenshotFromService || hasScreenshotFromSession;

  // if (screenshotSrc && screenshotSrc !== 'undefined' && screenshotSrc.trim() !== '') {
  //   const screenshotContainer = document.createElement('div');
  //   this.renderer.setStyle(screenshotContainer, 'position', 'absolute');
  //   this.renderer.setStyle(screenshotContainer, 'top', '15%');
  //   this.renderer.setStyle(screenshotContainer, 'left', '15%');
  //   this.renderer.setStyle(screenshotContainer, 'width', '70%');
  //   this.renderer.setStyle(screenshotContainer, 'height', '70%');
  //   this.renderer.setStyle(screenshotContainer, 'z-index', '1');
  //   this.renderer.setStyle(screenshotContainer, 'border-radius', '6px');
  //   this.renderer.setStyle(screenshotContainer, 'overflow', 'hidden');
  //   this.renderer.setStyle(screenshotContainer, 'box-shadow', '0 2px 8px rgba(0,0,0,0.3)');
  //   this.renderer.setStyle(screenshotContainer, 'border', '2px solid #ffffff');

  //   const screenshotImg = document.createElement('img');
  //   screenshotImg.src = screenshotSrc;
  //   screenshotImg.alt = this.device?.marketName || 'Device Screenshot';
  //   this.renderer.setStyle(screenshotImg, 'width', '100%');
  //   this.renderer.setStyle(screenshotImg, 'height', '100%');
  //   this.renderer.setStyle(screenshotImg, 'object-fit', 'cover');

  //   screenshotContainer.appendChild(screenshotImg);
  //   photo.appendChild(screenshotContainer);
  // }

  // a.appendChild(photo);

  // const name = document.createElement('div');
  // name.className = 'device-name';
  // this.renderer.setStyle(name, 'color', 'unset');
  // name.appendChild(document.createTextNode(this.device?.marketName || 'Device'));
  // a.appendChild(name);

  // const button = document.createElement('button');
  // this.renderer.setStyle(button, 'white-space', 'nowrap');
  // button.appendChild(document.createTextNode(''));
  // a.appendChild(button);

  // return li;

  // }


  // build(): HTMLLIElement {
  //   const li = document.createElement('li');
  //   this.renderer.setStyle(li, 'background-color', 'white');
  //   this.renderer.setStyle(li, 'width', '10em');
  //   this.renderer.setStyle(li, 'margin', '0');
  //   this.renderer.setStyle(li, 'box-shadow', '2px 2px 4px #88898d');

  //   this.renderer.listen(li, 'mouseenter', () => {
  //     this.renderer.setStyle(li, 'box-shadow', '6px 6px 4px rgba(0, 0, 0, 0.2)');
  //   });
  //   this.renderer.listen(li, 'mouseleave', () => {
  //     this.renderer.removeStyle(li, 'transform');
  //     this.renderer.setStyle(li, 'box-shadow', '2px 2px 4px #88898d');
  //   });
  //   this.renderer.listen(li, 'mousedown', () => {
  //     this.renderer.setStyle(li, "transform", "translateY(4px)");
  //   });

  //   li.className = 'cursor-select pointer thumbnail';

  //   const a = document.createElement('a');
  //   li.appendChild(a);

  //   const photo = document.createElement('div');
  //   photo.className = 'device-photo-small';

  //   const img = document.createElement('img');

  //   const serial = this.device?.serial;
  //   const imageHref = serial ? sessionStorage.getItem(`deviceScreenshot-${serial}`) : null;

  //   if (imageHref) {
  //     const fullUrl = imageHref;
  //     img.src = fullUrl;
  //   } else {
  //     img.src = 'assets/default-thumbnail.png';
  //   }

  //   img.alt = this.device?.marketName || 'Device Screenshot';
  //   photo.appendChild(img);
  //   a.appendChild(photo);

  //   const name = document.createElement('div');
  //   name.className = 'device-name';
  //   this.renderer.setStyle(name, 'color', 'unset');
  //   name.appendChild(document.createTextNode(this.device?.marketName || 'Device'));
  //   a.appendChild(name);

  //   const button = document.createElement('button');
  //   this.renderer.setStyle(button, 'white-space', 'nowrap');
  //   button.appendChild(document.createTextNode(''));
  //   a.appendChild(button);

  //   return li;
  // }

  build(): HTMLLIElement {


    const li = document.createElement('li');
    // aliceblue
    this.renderer.setStyle(li, 'background-color', 'white');
    this.renderer.setStyle(li, 'width', '10em');
    this.renderer.setStyle(li, 'margin', '0');
    this.renderer.setStyle(li, 'box-shadow', '2px 2px 4px #88898d');
    this.renderer.setStyle(li, 'border-radius', '8px');
    this.renderer.setStyle(li, 'padding', '5px');
    //for box shadows in device list icons
    this.renderer.listen(li, 'mouseenter', () => {
      this.renderer.setStyle(li, 'box-shadow', '6px 6px 4px rgba(0, 0, 0, 0.2)');
    });
    this.renderer.listen(li, 'mouseleave', () => {
      this.renderer.removeStyle(li, 'transform');
      this.renderer.setStyle(li, 'box-shadow', '2px 2px 4px #88898d');
    });
    this.renderer.listen(li, 'mousedown', () => {
      this.renderer.setStyle(li, "transform", "translateY(4px)");
      // this.renderer.setStyle(li, "transform", "translateX(4px)");
    });
    li.className = 'cursor-select pointer thumbnail';
    // the whole li is a link
    const a = document.createElement('a');
    li.appendChild(a);

    // .device-photo-small
    const photo = document.createElement('div');
    photo.className = 'device-photo-small';
    const img = document.createElement('img');
    photo.appendChild(img);
    a.appendChild(photo);

    // .device-name
    const name = document.createElement('div');
    name.className = 'device-name';
    this.renderer.setStyle(name, 'margin-top', '5px')
    this.renderer.setStyle(name, 'color', 'unset')
    name.appendChild(document.createTextNode(''));
    a.appendChild(name);

    // button
    const button = document.createElement('button');
    this.renderer.setStyle(button, 'white-space', 'nowrap')
    button.appendChild(document.createTextNode(''));
    a.appendChild(button);
    //new
    // li.appendChild(button);

    return li;
  }


  update(li: any, device: any) {
    let a = li.firstChild
    let img = a.firstChild.firstChild
    let name = a.firstChild.nextSibling
    let nt = name.firstChild
    let button = name.nextSibling

    const overlayText = `SIM: ${device.operator || 'No SIM'}\nGroup: ${device?.group.name}`;
    this.renderer.setAttribute(li, 'title', overlayText);
    if (device.enhancedStateAction == "Stop Using") {
      console.log(this.currentUser.userObj.privilege,"this.currentUser");
      if (device.owner?.name !== "admin") {
        if(this.currentUser.userObj.privilege == "admin"){
          this.renderer.setStyle(button, 'background-color', '#ff6426');
          this.renderer.setStyle(button, 'color', 'Black');
        }else{
          this.renderer.setStyle(button, 'background-color', '#167ffc');
          this.renderer.setStyle(button, 'color', 'white');
        }
      } else {
        this.renderer.setStyle(button, 'background-color', '#167ffc');
        this.renderer.setStyle(button, 'color', 'white');
      }
    }
    else if (device.enhancedStateAction == "Preparing") {
      this.renderer.setStyle(button, 'color', 'rgb(255 255 255)');
      this.renderer.setStyle(button, 'background-color', 'rgb(41 121 1)');
    }
    else {
      this.renderer.setStyle(button, 'background-color', '#eaeaea');
      this.renderer.setStyle(button, 'color', '#555');
    }
    let at = button.firstChild

    let classes = 'btn btn-xs device-status '
    if (device.biometricEnabled === true) {

      // Remove any existing biometric icon
      const existingBiometric = li.querySelector('.biometric-icon');
      if (existingBiometric) {
        this.renderer.removeChild(li, existingBiometric);
      }

      const biometricIcon = this.renderer.createElement('div');
      this.renderer.addClass(biometricIcon, 'biometric-icon');

      // Position and base styles
      this.renderer.setStyle(biometricIcon, 'position', 'absolute');
      this.renderer.setStyle(biometricIcon, 'top', '8px');
      this.renderer.setStyle(biometricIcon, 'right', '8px');
      this.renderer.setStyle(biometricIcon, 'width', '24px');
      this.renderer.setStyle(biometricIcon, 'height', '24px');
      this.renderer.setStyle(biometricIcon, 'border-radius', '50%');
      this.renderer.setStyle(biometricIcon, 'display', 'flex');
      this.renderer.setStyle(biometricIcon, 'align-items', 'center');
      this.renderer.setStyle(biometricIcon, 'justify-content', 'center');
      this.renderer.setStyle(biometricIcon, 'z-index', '10');
      this.renderer.setStyle(biometricIcon, 'cursor', 'pointer');

      this.renderer.setStyle(biometricIcon, 'background', '#667eea');
      this.renderer.setStyle(biometricIcon, 'box-shadow', '0 1px 3px rgba(0,0,0,0.2)');
      this.renderer.setStyle(biometricIcon, 'border', '1px solid rgba(255,255,255,0.3)');
      this.renderer.setStyle(biometricIcon, 'transition', 'all 0.2s ease');

      this.renderer.setProperty(biometricIcon, 'innerHTML',
        '<i class="fa-solid fa-fingerprint" style="color: white; font-size: 13px; font-weight: 600;"></i>'
      );
      this.renderer.listen(biometricIcon, 'mouseenter', () => {
        this.renderer.setStyle(biometricIcon, 'transform', 'scale(1.1)');
        this.renderer.setStyle(biometricIcon, 'background', '#764ba2');
        this.renderer.setStyle(biometricIcon, 'box-shadow', '0 2px 6px rgba(0,0,0,0.25)');
      });

      this.renderer.listen(biometricIcon, 'mouseleave', () => {
        this.renderer.setStyle(biometricIcon, 'transform', 'scale(1)');
        this.renderer.setStyle(biometricIcon, 'background', '#667eea'); // Back to original
        this.renderer.setStyle(biometricIcon, 'box-shadow', '0 1px 3px rgba(0,0,0,0.2)');
      });

      this.renderer.setProperty(biometricIcon, 'title', 'Biometric Authentication Enabled');

      this.renderer.appendChild(li, biometricIcon);
      this.renderer.addClass(li, 'biometric-enabled');
    } else {
      // console.log("Biometric Enabled false", device.biometricEnabled);

    }

    // .device-photo-small
    if (img.getAttribute('src') !== device.enhancedImage120 || device.ios) {
      img.setAttribute('src', device.enhancedImage120)
    }

    // .device-name
    nt.nodeValue = device.enhancedName;

    // button
    at.nodeValue = device.enhancedStateAction;

    let getStateClasses = (state) => {
      let stateClasses = {
        using: 'state-using btn-primary',
        busy: 'state-busy btn-warning',
        available: 'state-available btn-outline-primary',
        ready: 'state-ready btn-outline-primary',
        present: 'state-present btn-outline-primary',
        preparing: 'state-preparing btn-outline-primary btn-outline-success',
        unauthorized: 'state-unauthorized btn-outline-danger',
        offline: 'state-offline btn btn-light',
        automation: 'state-automation btn btn-light'
      }[state]
      if (typeof stateClasses === 'undefined') {
        stateClasses = 'btn btn-light'
      }
      return stateClasses
    }


    //stop-using button click  idar sai bhi call hota hai
    if (getStateClasses(device.state) === 'state-using btn-primary') {
      button.addEventListener('click', () => {
        this.groupService.kick(device);

        // this.Router.navigate(['devices']);
      });

    }


    button.className = classes + getStateClasses(device.state);

    if (device.state === 'available') {
      name.classList.add('state-available')
    } else {
      name.classList.remove('state-available')
    }

    if (device.usable && !device.using) {
      //a.href = '#!/control/' + device.serial
      // a.href = '';
      console.log("1.device.usable && !device.using", device.usable, device.using,"\n device.serial:",device.serial);
      li.classList.remove('device-is-busy')
    }
    else if (device.using && device.usable) {
      // a.href = '#!/control/' + device.serial
      //a.href = '';
      console.log("2.device.using && device.usable", device.using, device.usable,"\n device.serial:",device.serial);
    }
    else {
      a.removeAttribute('href')
      console.log("3.device.unusable or device.using", device.usable, device.using,"\n device.serial:",device.serial);
      li.classList.add('device-is-busy')
    }
    return li
  }

  addListener = (device: any) => {

    let item = this.createItem(device);


    this.filterItem(item, device);
    this.insertItem(item, device);
  };

  createItem(device: any) {
    let id = this.calculateId(device)
    let item = this.build();

    item.id = id;


    this.update(item, device)
    this.mapping[id] = device

    return item
  }

  // Filters an item, perhaps removing it from view.

  filterItem(item, device) {



    if (this.match(device)) {
      item.classList.remove('filter-out')

      if (item.className === 'cursor-select pointer thumbnail' || item.className === 'cursor-select pointer thumbnail device-is-busy') {
        item.style.display = ''

      }

    }
    else {
      item.classList.add('filter-out')

      if (item.className === 'cursor-select pointer thumbnail device-is-busy filter-out' || item.className === 'cursor-select pointer thumbnail filter-out') {



        item.style.display = 'none';
      }
      else {
        item.style.display = ''
      }
    }

  }


  // Checks whether the device matches the currently active filters.
  match(device) {


    for (let i = 0, l = this.activeFilters.length; i < l; ++i) {
      let filter = this.activeFilters[i]
      let column
      if (filter.field) {
        column = this.columnDefinitions[filter.field]
        if (column && !column.filter(device, filter)) {
          return false
        }
      }
      else {
        let found = false
        for (let j = 0, k = this.activeColumns.length; j < k; ++j) {
          column = this.columnDefinitions[this.activeColumns[j]]
          if (column && column.filter(device, filter)) {
            found = true
            break
          }
        }
        if (!found) {
          return false
        }
      }
    }
    return true
  }

  // Inserts an item into the table into its correct position according to
  // current sorting.
  insertItem(item, deviceA) {
    return this.insertItemToSegment(item, deviceA, 0, this.items.length - 1)
  }

  calculateId(device) {
    return this.prefix + device.serial
  }

  // Inserts an item into a segment of the table into its correct position
  // according to current sorting. The value of `hi` is the index
  // of the last item in the segment, or -1 if none. The value of `lo`
  // is the index of the first item in the segment, or 0 if none.
  insertItemToSegment(item, deviceA, low, high) {
    let total = this.items.length
    let lo = low
    let hi = high

    if (lo > hi) {
      // This means that `lo` refers to the first item of the next
      // segment (which may or may not exist), and we should put the
      // row before it.
      this.list.insertBefore(item, lo < total ? this.items[lo] : null)
    }
    else {
      let after = true
      let pivot = 0
      let deviceB

      while (lo <= hi) {
        pivot = ~~((lo + hi) / 2)
        deviceB = this.mapping[this.items[pivot].id];

        let diff = this.compare(deviceA, deviceB)

        if (diff === 0) {
          after = true
          break
        }

        if (diff < 0) {
          hi = pivot - 1
          after = false
        }
        else {
          lo = pivot + 1
          after = true
        }
      }

      if (after) {
        this.list.insertBefore(item, this.items[pivot].nextSibling)
      }
      else {
        this.list.insertBefore(item, this.items[pivot])
      }
    }
  }

  //updated compare function
  compare(deviceA: any, deviceB: any) {
    const mapping = {
      asc: 1,
      desc: -1
    };

    let diff: number;

    // First check the priority based on enhancedStateAction
    const textA = deviceA.enhancedStateAction;
    const textB = deviceB.enhancedStateAction;

    // Default to highest possible priority number
    let priorityA = Object.keys(this.priorityOrder).length;
    let priorityB = Object.keys(this.priorityOrder).length;

    // Find matching priorities
    for (const [key, value] of Object.entries(this.priorityOrder)) {
      if (textA.includes(key)) priorityA = value;
      if (textB.includes(key)) priorityB = value;
    }

    // If priorities are different, return their difference
    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }

    // If priorities are equal, continue with other sorting criteria
    for (let i = 0, l = this.activeSorting.length; i < l; ++i) {
      const sort = this.activeSorting[i];
      diff = this.columnDefinitions[sort.name].compare(deviceA, deviceB);
      if (diff !== 0) {
        diff *= mapping[sort.order];
        break;
      }
    }

    return diff;
  }
  //previous compare function which was comparing only on basis of activeSorting array
  // compare(deviceA: any, deviceB: any) {
  //   const mapping = {
  //     asc: 1,
  //     desc: -1
  //   };

  //   let diff: number;

  //   // Find the first difference
  //   for (let i = 0, l = this.activeSorting.length; i < l; ++i) {
  //     const sort = this.activeSorting[i];
  //     diff = this.columnDefinitions[sort.name].compare(deviceA, deviceB);
  //     if (diff !== 0) {
  //       diff *= mapping[sort.order];
  //       break;
  //     }
  //   }

  //   return diff;
  // }

  // Triggers when the tracker notices that a device changed.
  changeListener(device) {

    let id = this.calculateId(device)
    let item = this.list.children[id]


    if (item) {
      // First, update columns
      this.updateItem(item, device)

      // Maybe the item is not sorted correctly anymore?
      let diff = this.compareItem(item, device)


      if (diff !== 0) {
        // Because the item is no longer sorted correctly, we must
        // remove it so that it doesn't confuse the binary search.
        // Then we will simply add it back.
        this.list.removeChild(item)
        this.insertItem(item, device)
      }
    }
  }

  // Updates all the columns in the item. Note that the item must be in
  // the right format already (built with createItem() and patched with
  // patchItem() if necessary).
  updateItem(item, device) {
    let id = this.calculateId(device)
    // if(device.present==true && device.usable)
    // {

    //   device.enhancedStateAction='Use'
    // }
    item.id = id
    this.update(item, device)

    return item
  }

  // Compares an item to its siblings to see if it's still in the correct
  // position. Returns <0 if the device should actually go somewhere
  // before the previous item, >0 if it should go somewhere after the next
  // item, or 0 if the position is already correct.
  compareItem(item, device) {
    let prev = item.previousSibling
    let next = item.nextSibling
    let diff

    if (prev) {
      diff = this.compare(device, this.mapping[prev.id])
      if (diff < 0) {
        return diff
      }
    }

    if (next) {
      diff = this.compare(device, this.mapping[next.id])
      if (diff > 0) {
        return diff
      }
    }

    return 0
  }

  // Triggers when a device is removed entirely from the tracker.
  removeListener(device) {


    let id = this.calculateId(device)
    let item = this.list.children[id]

    if (item) {
      this.list.removeChild(item)
    }
    delete this.mapping[id]
  }

  // Sort all items.
  sortAll() {
    if (this.items) {
      // This could be improved by getting rid of the array copying. The
      // copy is made because items can't be sorted directly.
      const sorted = [].slice.call(this.items).sort((itemA, itemB) => {
        return this.compare(this.mapping[itemA.id], this.mapping[itemB.id])
      });

      // Now, if we just append all the elements, they will be in the
      // correct order in the table.
      for (let i = 0, l = sorted.length; i < l; ++i) {
        this.list.appendChild(sorted[i]);
      }
    }
  }

  // Patches all items.
  patchAll(patch) {
    for (let i = 0, l = this.items.length; i < l; ++i) {
      this.patchItem(this.items[i], this.mapping[this.items[i].id], patch)
    }
  }

  // Patches the given item by running the given patch operations in
  // order. The operations must take into account index changes caused
  // by previous operations.
  patchItem(item, device, patch) {
    // Currently no-op
  }

  // Update now so we're up to date. <--------------------- need to check
  // this.updateFilters(this.filter);

  // Updates filters on visible items.
  updateFilters(filters) {
    this.activeFilters = filters;
    return this.filterAll();
  }

  // Applies filteItem() to all items.
  filterAll() {


    for (let i = 0, l = this.items.length; i < l; ++i) {
      this.filterItem(this.items[i], this.mapping[this.items[i].id])
    }

  }

  // Updates visible columns. This method doesn't necessarily have to be
  // the fastest because it shouldn't get called all the time.
  updateColumns(columnSettings) {
    let newActiveColumns = []

    // Check what we're supposed to show now
    columnSettings.forEach(function (column) {
      if (column.selected) {
        newActiveColumns.push(column.name)
      }
    })

    // Figure out the patch
    let patch = this.patchArray(this.activeColumns, newActiveColumns)

    // Set up new active columns
    this.activeColumns = newActiveColumns

    return this.patchAll(patch)
  }

  patchArray(a, b) {
    let ops = []

    let workA = [].concat(a)
    let inA = Object.create(null)
    let itemA, cursorA, itemB, cursorB

    let inB = this.existenceMap(b)
    let posB = Object.create(null)

    // First, check what was removed from a.
    for (cursorA = 0; cursorA < workA.length;) {
      itemA = workA[cursorA]

      // If b does not contain the item, surely it must have been removed.
      if (!inB[itemA]) {
        workA.splice(cursorA, 1)
        ops.push(['remove', cursorA])
      }
      // Otherwise, the item is still alive.
      else {
        inA[itemA] = true
        cursorA += 1
      }
    }

    // Then, check what was inserted into b.
    for (cursorB = 0; cursorB < b.length; ++cursorB) {
      itemB = b[cursorB]

      // If a does not contain the item, it must have been added.
      if (!inA[itemB]) {
        workA.splice(cursorB, 0, itemB)
        ops.push(['insert', cursorB, itemB])
      }

      posB[itemB] = cursorB
    }

    // At this point, workA contains the same items as b, but swaps may
    // be needed.
    for (cursorA = 0; cursorA < workA.length;) {
      itemA = workA[cursorA]
      let posInB = posB[itemA]

      if (posInB === cursorA) {
        cursorA += 1
      }
      else {
        let temp = workA[posInB]
        workA[posInB] = itemA
        workA[cursorA] = temp
        ops.push(['swap', cursorA, posInB])
      }
    }
    return ops
  }

  existenceMap(array) {
    let map = Object.create(null)
    for (let i = 0, l = array.length; i < l; ++i) {
      map[array[i]] = 1
    }
    return map
  }

  // Sorting
  sortBy(column: any, multiple: boolean): void {
    const findInSorting = (sorting: any[]): any => {
      return sorting.find((item) => item.name === column.name) || null;
    };

    const swap = {
      asc: 'desc',
      desc: 'asc'
    };

    const fixedMatch = findInSorting(this.sort.fixed);
    if (fixedMatch) {
      fixedMatch.order = swap[fixedMatch.order];
      return;
    }

    const userMatch = findInSorting(this.sort.user);
    if (userMatch) {
      userMatch.order = swap[userMatch.order];
      if (!multiple) {
        this.sort.user = [userMatch];
      }
    } else {
      if (!multiple) {
        this.sort.user = [];
      }
      this.sort.user.push({
        name: column.name,
        order: this.columnDefinitions[column.name].defaultOrder || 'asc'
      });
    }
  }

  checkDeviceStatus(serial: any) {
    return this.deviceService.checkDeviceStatus(serial);
  }

  checkGroupValidation(groupId: any, deviceSerial: any) {
    //for new backend
    this.automationService.validationUsersAsPerGroup(groupId, deviceSerial);
  }


  // Update now so that we don't have to wait for the scope watcher to<---------------need to check
  // trigger.
  // updateColumns(scope.columns());

  kickDevice(device: any, force?: boolean) {

    this.stackService.delete(device.serial);
    if (Object.keys(this.logcatService.deviceEntries).includes(device.serial)) {
      this.logcatService.deviceEntries[device.serial].allowClean = true;

      this.bridgeHost = device.providerUrl;
      this.automationService.stopAppInspector('', device.serial, this.bridgeHost).subscribe((res: any) => {

        sessionStorage.setItem("appInspectorUrl", null);
      });
    }

    // this.Router.navigate(['/devices']);

    // this.logcatService.allowClean = true;   // dont know what this is
    // $rootScope.LogcatService = this.logcatService; // Not sure what the equivalent would be in Angular

    return this.groupService.kick(device, force).catch((e: any) => {
      this.msg = "Device kicked from the group";
      this.openAlertMod(this.alertTemplate, this.msg);
      // alert('Device kicked from the group');
      throw new Error(e);
    });
  }

  inviteDevice(device) {
    // return GroupService.invite(device).then(function () {
    //   scope.$digest()
    // })
  }

  openAlertMod(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
    setTimeout(() => {
      this.modalRef.close();;
      this.msg = "";
    }, 1500)
  }

  openAlertMod2(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
  }

  Ok() {
    this.modalRef.close();;
    this.msg = "";
  }

  Yes() {
    this.checkGroupValidation(this.groupId, this.device.serial);
    this.modalRef.close();;
    this.msg = "";
  }

  No() {
    this.modalRef.close();;
    this.msg = "";
    this.device = null;
  }

  Reload() {
    window.location.reload();
  }
}
